"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ConfigDataUtil {
    analyticsScriptIsV1(analyticsScript) {
        return analyticsScript.match(/^UA-\d{4,9}-\d{1,4}$/);
    }
}
exports.default = new ConfigDataUtil();
